import getEnvironDomain from 'ati-utils/getEnvironDomain';
import wrapInObserver from '../wrapInObserver';
import logger from '../../logger';
import generatedHooks from '../../hooks/generatedHooks';
import GeoSearch from './GeoSearch';
import { makeValue } from '../../stores/suggestion';

const {
  useGeoStore, useRootStore,
} = generatedHooks;

const mapProps = () => {
  try {
    const geoStore = useGeoStore(store => store);
    const rootStore = useRootStore(store => store);

    const {
      setSelectedSuggestion,
      clearSuggestions,
    } = geoStore;

    const handleSuggestionsClear = clearSuggestions;

    const handleSelect = (suggestion) => {
      if (suggestion) {
        const newSuggestion = {
          text: suggestion.address,
          id: suggestion.geoId,
          type: suggestion.geoType,
          value: makeValue(suggestion.geoType, suggestion.geoId),
        };
        setSelectedSuggestion(newSuggestion);
      } else {
        clearSuggestions();
      }

      rootStore.reload();
    };

    return {
      handleSelect,
      handleSuggestionsClear,
      baseUrl: `https://${getEnvironDomain()}`,
    };
  } catch (error) {
    logger.log(error);
    return {};
  }
};

export default wrapInObserver(GeoSearch, mapProps);
